import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { Supplier } from "./supplier.entity";
import { Farm } from "./farms.entity";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('farms_log')
export class FarmsLog {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @Column("char", {
        nullable: false,
        length: 50,
        name: "code"
    })
    @Index({ unique: true })
    farmCode: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "name"
    })
    farmName: string;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "address"
    })
    address: string;
    @Column("int", {
        nullable: false,
        name: "no_of_acres"
    })
    NumberOfAcres: number;
    @Column("int", {
        nullable: false,
        name: "no_of_ponds"
    })
    numberOfPonds: number;
    @Column("varchar", {
        nullable: false,
        length: 100,
        name: "trace_code"
    })
    traceCode: string;
    @Column("int", {
        nullable: false,
        name: "certification_id"
    })
    certificationId: number;

    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "certification_code"
    })
    certificationCode: string;

    @Column("date", {
        nullable: false,
        name: "exp_date"
    })
    expiryDate: Date;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "mobile_no"
    })
    mobileNumber: string;
  
    @Column({
        name: "effective_from",
        type: 'datetime'
      })
      effectiveFrom: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @Column("boolean", {
        nullable: true,

        name: "culture_status"
    })
    cultureStatus: boolean;
    
    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "dealer"
    })
    dealerName: string;
    
    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "seed"
    })
    seed: string;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "feed"
    })
    feed: string;  
    
    @Column("varchar", {
        nullable: true,
        name: "remarks"
    })
    remarks: string;

    @Column("varchar", {
        nullable: true,
        name: "comments"
    })
    comments: string;

    @Column("int", {
        nullable: true,
        name: "area_under_culture_in_acrs"
    })
    AreaUnderCultureInAcrs: number;

    @Column("int", {
        nullable: true,
        name: "qty_stock"
    })
    qtyStock: number;
    @Column("varchar", {
        nullable: true,
        name: "date_of_stock_in"
    })
    dateOfStockIn: Date;
    @Column("int", {
        nullable: true,
        name: "day_of_culture"
    })
    dayOfCulture: number;
    @Column("int", {
        nullable: true,
        name: "count"
    })
    count: number;
    @Column("int", {
        nullable: true,
        name: "biomass_in_mts"
    })
    biomassInMts: number;

    
    @ManyToOne(type => Farm, e => e.farmLogInfo, { nullable: false, })
    @JoinColumn({ name: "ref_id" })
    farmInfo: Farm;

}
